module.exports = __webpack_public_path__ + "static/media/4_graph.42ff18c2.svg";